import { ClipboardCheck, Briefcase, ShieldCheck, Bell } from 'lucide-react';

export const getNotificationIcon = (type: string) => {
  switch (type) {
    case 'evidence_submitted':
      return ClipboardCheck;
    case 'bid_submitted':
    case 'bid_accepted':
    case 'bid_rejected':
      return Briefcase;
    case 'task_approved':
    case 'task_rejected':
      return ShieldCheck;
    default:
      return Bell;
  }
};
